import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "regionSelect", "regionTextInput"]
  static values = { regions: Object }

  connect() {
    this.syncRegionField()
  }

  countryChanged() {
    this.syncRegionField()
  }

  syncRegionField() {
    const countryCode = this.countrySelectTarget.value
    const regions = this.regionsValue[countryCode] || []
    const previousValue = this.regionSelectTarget.value || this.regionTextInputTarget.value

    if (regions.length > 0) {
      this.renderRegionOptions(regions, previousValue)
      this.regionSelectTarget.disabled = false
      this.regionSelectTarget.classList.remove("hidden")
      this.regionTextInputTarget.disabled = true
      this.regionTextInputTarget.classList.add("hidden")
      return
    }

    this.regionTextInputTarget.value = previousValue
    this.regionSelectTarget.disabled = true
    this.regionSelectTarget.classList.add("hidden")
    this.regionTextInputTarget.disabled = false
    this.regionTextInputTarget.classList.remove("hidden")
  }

  renderRegionOptions(regions, previousValue) {
    this.regionSelectTarget.innerHTML = [
      '<option value="">Bitte wählen</option>',
      ...regions.map((region) => `<option value="${this.escapeHtml(region)}">${this.escapeHtml(region)}</option>`)
    ].join("")

    if (regions.includes(previousValue)) {
      this.regionSelectTarget.value = previousValue
    } else {
      this.regionSelectTarget.value = ""
    }
  }

  escapeHtml(value) {
    return value
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }
}
